// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------modal---------------- */

.PaymentsFilters_boxModal__vJ2bI {
  animation: PaymentsFilters_init__uDW9T 0.3s;
  transition: 1s;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  overflow: scroll;
  overflow-x: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 90%;
  border-radius: 5px;
  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_exit__rl76- {
  width: 90%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 40px;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_exit__rl76- .PaymentsFilters_exitIcon__rNQx4 {
  transition: 0.3s;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_exit__rl76- .PaymentsFilters_exitIcon__rNQx4:hover {
  transition: 0.2s;
  scale: 1.3;
  cursor: pointer;
  filter: brightness(1.6);
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_titleModal__VqTju {
  width: 95%;
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: flex-start;
  margin-top: 15px;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_titleModal__VqTju p {
  font-size: 1.3rem;
  margin: 0;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_titleModal__VqTju span {
  font-size: 1rem;
  color: #5a5a5a;
  margin: 5px 0 0;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_loader__IIDdS {
  transition: 0.5s;
  min-height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_item__-XAbG {
  margin-bottom: 15px;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_item__-XAbG p {
  margin: 0;
  margin-bottom: 5px;
  font-size: 1rem;
  font-weight: 300;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_item__-XAbG .PaymentsFilters_icon__d2rBw {
  transition: 0.3s;
}

.PaymentsFilters_boxModal__vJ2bI .PaymentsFilters_item__-XAbG .PaymentsFilters_icon__d2rBw:hover {
  transition: 0.3s;
  filter: brightness(1.1);
  scale: 1.1;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Pagos/Filters/PaymentsFilters.module.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C;EACE,2CAAoB;EACpB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB","sourcesContent":["/* -----------------modal---------------- */\n\n.boxModal {\n  animation: init 0.3s;\n  transition: 1s;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  overflow: scroll;\n  overflow-x: hidden;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-height: 90%;\n  border-radius: 5px;\n  box-shadow: 0 5px 50px -3px rgba(0, 0, 0, 0.511);\n}\n\n.boxModal .exit {\n  width: 90%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 30px;\n  margin-top: 20px;\n  margin-bottom: 40px;\n}\n\n.boxModal .exit .exitIcon {\n  transition: 0.3s;\n}\n\n.boxModal .exit .exitIcon:hover {\n  transition: 0.2s;\n  scale: 1.3;\n  cursor: pointer;\n  filter: brightness(1.6);\n}\n\n.boxModal .titleModal {\n  width: 95%;\n  display: flex;\n  flex-direction: column;\n  justify-items: center;\n  align-items: flex-start;\n  margin-top: 15px;\n}\n\n.boxModal .titleModal p {\n  font-size: 1.3rem;\n  margin: 0;\n}\n\n.boxModal .titleModal span {\n  font-size: 1rem;\n  color: #5a5a5a;\n  margin: 5px 0 0;\n}\n\n.boxModal .loader {\n  transition: 0.5s;\n  min-height: 40vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 2rem;\n}\n\n.boxModal .item {\n  margin-bottom: 15px;\n}\n\n.boxModal .item p {\n  margin: 0;\n  margin-bottom: 5px;\n  font-size: 1rem;\n  font-weight: 300;\n}\n\n.boxModal .item .icon {\n  transition: 0.3s;\n}\n\n.boxModal .item .icon:hover {\n  transition: 0.3s;\n  filter: brightness(1.1);\n  scale: 1.1;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxModal": `PaymentsFilters_boxModal__vJ2bI`,
	"init": `PaymentsFilters_init__uDW9T`,
	"exit": `PaymentsFilters_exit__rl76-`,
	"exitIcon": `PaymentsFilters_exitIcon__rNQx4`,
	"titleModal": `PaymentsFilters_titleModal__VqTju`,
	"loader": `PaymentsFilters_loader__IIDdS`,
	"item": `PaymentsFilters_item__-XAbG`,
	"icon": `PaymentsFilters_icon__d2rBw`
};
export default ___CSS_LOADER_EXPORT___;
